import { Injectable } from "@angular/core";
import { HttpClient, HttpParams } from "@angular/common/http";
import { map } from "rxjs/operators";
import { AppSettings } from "../../../config/config";
import { apiConstants } from "../../constant/apiConstant";

export interface StudentCheckInRecord {
  studentFullName: string;
  studentImage: string | null;
  classNumber: string;
  classDivision: string;
  fatherName: string;
  fatherMobileNumber: string;
  checkInTime: string | null;
  checkInBy: string | null;
  checkOutTime: string | null;
  checkOutBy: string | null;
}

export interface GetStudentCheckInParams {
  staffId: number | string;
  classCategoryId: string;
  classId: string;
  classStandardId: string;
  searchedStudentName: string;
  pageNumber: number;
  pageLimit: number;
  filterDate: string;
}

export interface GetStudentCheckInResponse {
  status: boolean;
  message?: string;
  body?: {
    studentCheckInCheckOutData: StudentCheckInRecord[];
    totalStudents: number;
    totalCheckedInStudents: number;
    totalCheckedOutStudents: number;
    maxPageNumber: number;
  };
}

export interface CheckInFilterOption {
  label: string;
  value: string;
}

interface WingListResponse {
  status: boolean;
  body?: { classCategoryListDetails: CheckInFilterOption[] };
}

interface ClassListResponse {
  status: boolean;
  body?: { classCategoryListData: CheckInFilterOption[] };
}

interface SectionListResponse {
  status: boolean;
  body?: { classSectionListData: CheckInFilterOption[] };
}

@Injectable({ providedIn: 'root' })
export class StaffCheckInService {
  private url = AppSettings.API_ENDPOINT_STAFF;

  constructor(private http: HttpClient) {}

  getStudentCheckInList(params: GetStudentCheckInParams) {
    const httpParams = new HttpParams()
      .set('lang', 'en')
      .set('staffId', String(params.staffId))
      .set('classCategoryId', params.classCategoryId)
      .set('classId', params.classId)
      .set('classStandardId', params.classStandardId)
      .set('searchedStudentName', params.searchedStudentName)
      .set('pageNumber', String(params.pageNumber))
      .set('pageLimit', String(params.pageLimit))
      .set('filterDate', params.filterDate);
    return this.http
      .get<GetStudentCheckInResponse>(this.url + apiConstants.getStudentCheckInInfo, { params: httpParams })
      .pipe(map((res) => res));
  }

  getWingOptions() {
    const params = new HttpParams().set('lang', 'en');
    return this.http
      .get<WingListResponse>(this.url + apiConstants.getCheckInWingData, { params })
      .pipe(map((res) => res));
  }

  getClassOptions(classCategoryId: string) {
    const params = new HttpParams().set('lang', 'en').set('classCategoryId', classCategoryId);
    return this.http
      .get<ClassListResponse>(this.url + apiConstants.getCheckInClassData, { params })
      .pipe(map((res) => res));
  }

  getSectionOptions(classCategoryId: string, classStandardId: string) {
    const params = new HttpParams()
      .set('lang', 'en')
      .set('classCategoryId', classCategoryId)
      .set('classStandardId', classStandardId);
    return this.http
      .get<SectionListResponse>(this.url + apiConstants.getCheckInClassStandardData, { params })
      .pipe(map((res) => res));
  }
}
